import { render, staticRenderFns } from "./LoadingBar.vue?vue&type=template&id=a8fa56a2&scoped=true"
import script from "./LoadingBar.vue?vue&type=script&lang=ts"
export * from "./LoadingBar.vue?vue&type=script&lang=ts"
import style0 from "./LoadingBar.vue?vue&type=style&index=0&id=a8fa56a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fa56a2",
  null
  
)

export default component.exports